import React from "react";
import Project from "./Project";
import projectsData from "../custom/projectData";

function Projects() {
  const projects = projectsData();
  return (
    <section id="project" className="special-back reverse py-5 ">
      <div className="container">
        <small
          className="text-secondary fw-bold text-uppercase fs-5"
          data-aos="fade-up"
        >
          Portfolio
        </small>
        <h3 className="mt-2 fs-4 fw-bolder mb-5" data-aos="fade-up">
          Each project is a unique piece of development 🧩
        </h3>
        {projects.map((project, index) =>
          index % 2 === 0 ? (
            <Project prData={project} key={index} placementCard="" />
          ) : (
            <Project
              prData={project}
              key={index}
              placementCard="flex-row-reverse"
            />
          )
        )}
      </div>
    </section>
  );
}

export default Projects;
